export default "__VITE_PUBLIC_ASSET__293e80fa__"